/**
 * Translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copiar'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nome',
    PROFIT_MARGIN: 'Margem de lucro'
  },
  LABEL: {
    GENERATE_LINK: 'Gerar link',
    GENERATED_LINK: 'Link gerado',
    NAME: 'Nome',
    PROFIT_MARGIN: 'Margem de lucro'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Link copiado'
  },
  TOOLTIP: {
    NAME: 'Nome',
    PROFIT_MARGIN: 'Margem de lucro'
  }
};
